export default __webpack_public_path__ + "static/media/222.3b6851ce.svg";